import packageJson from "../package.json";

type ConfigType = {
  HOSTNAME: string | undefined;
  STRICT_MODE: boolean;
  KEYCLOAK_ENABLED: boolean;
  NATIVE_ENABLED: boolean;
  DISABLE_SSL: boolean;
  VERSION: string | undefined;
  API_URL: string;
  MARKETING_URL: string;
  FIREBASE_API_KEY: string;
  FIREBASE_AUTH_DOMAIN: string;
  FIREBASE_PROJECT_ID: string;
  FIREBASE_STORAGE_BUCKET: string;
  FIREBASE_MESSAGING_SENDER_ID: string;
  FIREBASE_APP_ID: string;
  FIREBASE_MEASUREMENT_ID: string;
  STRIPE_PUBLISHABLE_KEY: string;
};

const Config: ConfigType = {
  HOSTNAME: process.env.REACT_APP_HOSTNAME,
  STRICT_MODE: process.env.REACT_APP_REACT_STRICT === "true",
  KEYCLOAK_ENABLED: process.env.REACT_APP_KEYCLOAK_ENABLED === "true",
  NATIVE_ENABLED: process.env.REACT_APP_NATIVE_ENABLED === "true",
  DISABLE_SSL: process.env.REACT_APP_DISABLE_SSL === "true",
  VERSION: process.env.REACT_APP_VERSION || `v${packageJson.version}`,
  API_URL: process.env.REACT_APP_API_URL || "https://app.data-revival.com",
  // Trailing slash stripped so callers can concatenate a leading-slash path
  // without producing a double slash. Defaults to the www host the apex
  // 308-redirects to, saving every click a redirect.
  MARKETING_URL: (
    process.env.REACT_APP_MARKETING_URL || "https://www.data-revival.com"
  ).replace(/\/+$/, ""),
  FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY || "",
  FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  FIREBASE_MESSAGING_SENDER_ID:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID || "",
  FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "",
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "",
};

export default Config;

// Absolute URL to a page on the marketing site (data-revival.com). Single
// source so the public navbar and footer can't drift apart.
export const marketingUrl = (path: string): string =>
  `${Config.MARKETING_URL}${path}`;
